// #region ENUMERABLES

export enum ENVIRONMENT {
  develop = 'dev',
  qa = 'pdn.release',
  production = 'pdn.prd'
}

export enum DEVHOST {
  host = ':8089'
}

export enum PassengerType {
  Adult = 'adult',
  Child = 'child',
  Infant = 'infant',
  Senior = 'senior'
}

export enum ValueType {
  Fixed = 'fixed',
  Percentage = 'percentage'
}

export enum TypeOfAisleSeat {
  AisleSeat = 'AisleSeat',
  LeftSideOfAircraft = 'LeftSideOfAircraft',
  RightSideOfAircraft = 'RightSideOfAircraft',
  CentralSideOfAircraft = 'CenterSectionSeatS',
  NoSeatAtThisLocation = 'NoSeatAtThisLocation'
}

export enum GDSType {
  Sabre = 'adult',
  Amadeus = 'child',
  Travelport = 'travelport'
}

export enum OptionType {
  ClosePNR = 'closePNR',
  PenaltyFarebasis = 'penalty',
  Cancellation = 'cancellation',
  SpecialRequest = 'specialRequest',
  Layout = 'layout',
  Dashboard = 'dashboard',
  Auth = 'auth',
  SearchResult = 'searchResult',
  VoluntaryChange = 'voluntaryChanges',
  InvoluntaryChange = 'involuntaryChanges',
  ExchangeNoCost = 'exchangeNoCost',
  AlternativeFlow = 'alternativeFlow',
  NameChange = 'nameChanges',
  OpenTicket = 'openTicket',
  Split = 'split',
  Log = 'operationLog',
  History = 'history',
  ItineraryHistory = 'itineraryHistory',
  AirCompanyNotes = 'airCompanyNotes',
  TicketHistory = 'ticketHistory',
  Integrations = 'integrations',
  Reissue = 'reissue',
  ReRoute = 'reRoute',
  Settings = 'settings',
  Availability = 'availability',
  NA = 'NA'
}

export enum ExceptionProcessType {
  Contingency = '1',
  Exception = '2'
}

export enum PAGETYPE {
  dashboard = 'dashboard',
  itinerary = 'itinerary',
  cancellation = 'cancellation',
  voluntaryChange = 'voluntary-change',
  involuntaryChange = 'involuntary-change',
  specialRequests = 'special-requests',
  reRoute = 're-route',
  newFlow = 'new-flow',
  backToNewFlow = 'new-flow/false',
  endProcess = 'end-process',
  pnrHistory = 'itinerary/history',
  itineraryHistory = 'itinerary/itineraryHistory',
  itineraryInfo = 'itinerary/info'
}

export enum LogTypes {
  Cancellation = 'cancellationQuote',
  SpecialRequest = 'specialRequest',
  Split = 'split',
  VoluntaryChange = 'voluntaryChanges',
  InvoluntaryChange = 'involuntaryChanges'
}

export enum AlertType {
  Warning = 'warning',
  Error = 'error',
  Default = 'default',
  Success = 'success',
  Muted = 'muted',
  Info = 'info'
}

export enum StepState {
  Normal = 'normal',
  Active = 'active',
  Completed = 'completed',
  Error = 'error',
  Muted = 'muted'
}

// Special request
export enum RequestState {
  Confirmed = 'confirmed',
  Denied = 'denied',
  Rejected = 'rejected',
  Pending = 'pending',
  NotDefined = 'notdefined'
}

export enum OverrideType {
  Fares = 'fares',
  Penalties = 'penalties',
  Taxes = 'taxes',
  FixedCharges = 'charges',
  RefundNet = 'net'
}

export enum OperationStatus {
  Start = 'start',
  End = 'end'
}

export enum ItineraryType {
  Multidestiny = 'multidestiny',
  OneWay = 'oneway',
  RoundTrip = 'roundtrip'
}

export enum SegmentType {
  Departure = 'departure',
  Return = 'return',
  Route = 'route'
}

export enum GenderType {
  Female = 'Female',
  Male = 'Male',
  Undefined = 'Undefined'
}

export enum PaymentType {
  Cash = 'Cash',
  CreditCard = 'CreditCard',
  CreditCardApprovalCode = 'CreditCardApprovalCode'
}

export enum CreditCardDevelop {
  token = '371445506710324',
  cvv = '4880',
  appCode = '1518',
  expYear = '29',
  expMonth = '04'
}

export enum FranchiseType {
  Amex = 'ax',
  Visa = 'vi',
  MasterCard = 'ca',
  Access = 'xs',
  Diners = 'dc',
  UATP = 'tp',
  JCB = 'jc',
  Discover = 'ds',
  NewZealandBank = 'bz',
  None = 'none',
  VisaBA = 'BA',
  MascerCardIK = 'IK',
  Credencial = 'credencial'
}

export enum PaymentStatusType {
  Failed = 'failed',
  Approved = 'approved',
  Pending = 'pending'
}

export enum CouponEmdType {
  S = 'S',
  A = 'A'
}

export enum ENDPROCESS {
  endProcessOnSalesForce = 'endProcessOnSalesForce',
  reloadedPage = 'reloadedPage'
}

export enum StatusType {
  Start, //0
  Success, //1
  Failure, //2
  FinishByUser, //3
  Search, //4
  TimeOut, //5
  failureUser, // 6
  successClient // 7
}

export enum ActionType {
  Cancellation, //0 VOID TRANSACTION
  Change, //1 VOL CHANGE
  Reschedule, //2 INVOL CHANGE
  SpecialRequest, //3
  TicketOpening, //4 OPEN TICKET
  NA //5
}

export enum ActionTypeText {
  Cancellation = 'Cancellation',
  Change = 'Change',
  Reschedule = 'Reschedule',
  SpecialRequest = 'SpecialRequest',
  TicketOpening = 'TicketOpening',
  NA = 'NA'
}

export enum LOCALSTORAGEVARS {
  FormExchanges = 'formExchanges',
  redirectFromManual = 'redirectFromManual',
  redirectFromAutomatic = 'redirectFromAutomatic',
  skipClearPnrInfo = 'skipClearPnrInfo'
}

export enum OSIS_VALIDATORS {
  APIN = 'apin-'
}

export enum TOURCODE_VALIDATORS {
  MXLA = '4mxla'
}

export enum TICKET_STATUS {
  Open = 'open',
  Used = 'used',
  Control = 'control',
  CTRL = 'ctrl',
  AirportControl = 'airportControl'
}

export enum FLOW_TYPE {
  Manual = 'manual',
  Automatic = 'automatic'
}

export enum WARNING_TEXT {
  PNR_MODIFIED = 'PNR MODIFIED - CHECK NAME IN PAX'
}

// #region CONSTANTS

export const REGEX_CODES = {
  matchNumbersStrings: /[a-zA-Z]+|[0-9]+/g
};

export const EPR_ROBOTIC_AEROMEXICO = {
  username: '120140',
  password: 'TPCH4NG3',
  sine: '15Q',
  dutyCode: '5',
  office: 'MX',
  pcc: 'AM',
  ipcc: 'CNA',
  station: '86976945'
};

export const ALLOWED_CHANGES_PLACEHOLDER_MESSAGES = {
  voluntaryChange: 'Voluntary change not allowed',
  involuntaryChange: 'Involuntary change not allowed'
};

export const enum CabinTypes {
  First = 'first',
  Business = 'business',
  Economy = 'economy',
  Any = 'any'
}

export const GDSs = [
  { id: 'Sabre', code: 'sabre', name: 'Sabre' },
  { id: 'Amadeus', code: 'amadeus', name: 'Amadeus' },
  { id: 'Worldspan', code: 'worldspan', name: 'Worldspan' },
  { id: 'SabreAirline', code: 'sabreAirline', name: 'SabreAirline' }
];

export const FareTypes = [
  { code: 'fare-difference', name: 'fare-difference' },
  { code: 'without-cost', name: 'without-cost' }
];

export const KEYWORDS = [
  'NON-REFUNDABLE',
  'CHARGE',
  'CANCELLATIONS',
  'CHILD/INFANT DISCOUNT',
  'DISCOUNTS APPLY',
  'DISCOUNT'
];

export const TOURCODES_SELECT = [{ name: 'RAC474', code: 'ITRAC474' }];

export const STATUS_TYPE_MESSAGE = [
  { code: StatusType.FinishByUser, name: 'shared.byuser' },
  { code: StatusType.successClient, name: 'shared.success' },
  { code: StatusType.failureUser, name: 'shared.failure' }
];

export const MENU_ACTION_TYPES = [
  {
    id: 'Cancellation',
    code: OptionType.Cancellation,
    name: OptionType.Cancellation,
    isDisabled: false,
    isAvailableAffectation: true
  },
  {
    id: 'SpecialRequest',
    code: OptionType.SpecialRequest,
    name: OptionType.SpecialRequest,
    isDisabled: false,
    isAvailableAffectation: true
  },
  {
    id: 'Voluntary',
    code: OptionType.VoluntaryChange,
    name: OptionType.VoluntaryChange,
    isDisabled: false,
    isAvailableAffectation: false
  },
  {
    id: 'OpenTicket',
    code: OptionType.OpenTicket,
    name: OptionType.OpenTicket,
    isDisabled: false,
    isAvailableAffectation: true
  },
  {
    id: 'Involuntary',
    code: OptionType.ExchangeNoCost,
    name: OptionType.ExchangeNoCost,
    isDisabled: false,
    isAvailableAffectation: false
  }
];

export const LANGUAGES_SELECT = [
  { code: 'na', name: 'language.default' },
  { code: 'es-MX', name: 'language.spanish' },
  { code: 'en', name: 'language.english' },
  { code: 'es-CO', name: 'language.spanishCo' },
  { code: 'pt', name: 'language.portuguese' }
];
